var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bs-example",attrs:{"fluid":""}},[_c('b-table',{attrs:{"striped":"","responsive":"","fields":_vm.visibleFields,"items":_vm.sortededList,"primary-key":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }